import { jsxs as e, jsx as t } from "react/jsx-runtime";

import o from "@ui-components-3/icons/lib/solid/CaretDown";

import s from "../../../Menu/index.js";

import i from "../../hooks/useTableContext/index.js";

import r from "../../../../utils/classNames/index.js";

const n = ({opt: e, onClick: o, isSelected: s}) => t("button", {
    type: "button",
    className: r("btn-unsized btn-neutral-borderless m-xxs font-normal", s && "font-semibold"),
    onClick: o,
    children: e
}), l = ({className: l, disabled: a, ...p}) => {
    const {model: c, colorVariant: d, scrollToTop: m} = i();
    if ("production" !== process.env.NODE_ENV && !c) throw new Error('RowsPerPage component is only supported within tables using "useTable"');
    if (!c) return null;
    const u = c?.getState();
    if (!u) return null;
    const f = u.pagination.pageSize, b = c.pageSizeOptions;
    /* model.pageSizeOptions defaults to DEFAULT_PAGE_OPTIONS */    if (!b.includes(f)) throw new Error('Current pageSize is not supported in the "pageSizeOptions" supplied to "useTable".');
    const g = c?.isLoading || a;
    return e("div", {
        ...p,
        className: r("gap-m mr-xs flex min-w-[190px] items-center justify-end", l),
        children: [ t("p", {
            className: "typography-body-l text-neutral",
            children: "Rows Per Page:"
        }), e(s, {
            items: b.map((e => t(n, {
                opt: e,
                onClick: () => {
                    c?.setPageSize(e), m();
                },
                isSelected: f === e
            }, e))),
            "aria-label": "Select rows per page",
            className: "gap-xs typography-body-l flex items-center",
            disabled: g,
            children: [ f, t(o, {
                "aria-hidden": "true",
                className: r("h-auto w-3", "primary" === d ? "fill-primary" : "secondary" === d ? "fill-secondary" : "fill-neutral", !!g && "!fill-neutral-400")
            }) ]
        }) ]
    });
};

export { l as default };
//# sourceMappingURL=index.js.map
